import { getCurrentEnv } from "./environment";
import scripts from "../config/scripts.json";

const injectScripts = (envScripts) => {
    for (const key in envScripts) {
        if (Object.hasOwnProperty.call(envScripts, key)) {
            const scriptUrl = envScripts[key];

            let script = document.querySelector(`script[src="${scriptUrl}"]`);

            if (!script) {
                let script = document.createElement("script");
                script.src = scriptUrl;
                script.async = true;
                if (key === "nav-footer") {
                    script.setAttribute("data-use-identity", "true");
                }
                document.body.appendChild(script);
            }
        }
    }
};

export const injectUserConsent = () => {
    const scriptUrl = "https://cdn.nba.com/user-consent/index.min.js";

    let script = document.querySelector(`script[src="${scriptUrl}"]`);
    if (!script) {
        let script = document.createElement("script");
        script.src = scriptUrl;
        document.body.appendChild(script);

        setTimeout(() => {
            let scriptAction = document.createElement("script");
            scriptAction.innerHTML = `
(function initalizeUserConsent(win) {
    // Set required parameters
    win.WM.UserConsentConfig = {
        brand: "NBA",
        cookieDomain: ".nba.com",
        domId: "d0494fd0-8921-497a-8323-e3d29775ce1b",
        src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
    };
    // If your site will provide the user's country code via a cookie
    // other than 'countryCode', give that name here. If your site sets
    // a 'countryCode' cookie, this line and the next can be omitted.
    win.WM.UserConsentConfig.ccCookie = "countryCode";

    // If your site cannot provide the country ID with a cookie, but will
    // provide the user's country code via a window object, set that here.
    // NBA.com uses window._esi.country
    // win.WM.UserConsentConfig.countryCode = window._esi ? window._esi.
    // country : "",
    // Call init()
    win.WM.UserConsent.init(win.WM.UserConsentConfig);
})(window);`;
            document.body.appendChild(scriptAction);
        }, 3000);
    }
};

export const injectMainScripts = () => {
    console.log("injectMainScripts");

    const currentEnv = getCurrentEnv();
    const envScripts = currentEnv && currentEnv !== "prod" ? scripts.main[currentEnv] : scripts.main.prod;
    injectScripts(envScripts);
};

export const injectPageScripts = () => {
    console.log("injectPageScripts");

    const currentEnv = getCurrentEnv();
    const envScripts = currentEnv && currentEnv !== "prod" ? scripts.page[currentEnv] : scripts.page.prod;
    injectScripts(envScripts);
};
